import CurrencyInput from "@/components/shared/CurrencyInput";

const AssetRow = ({ name, amount, onChange }) => (
  <div className="flex items-center justify-between py-3 px-4 bg-gray-50 rounded-lg mb-2">
    <span className="text-gray-700">{name}</span>
    <CurrencyInput
      value={amount}
      onChange={onChange}
      className="w-36 px-3 py-2 text-right rounded-lg bg-white border border-gray-200 focus:border-teal-400 focus:ring-2 focus:ring-teal-100"
    />
  </div>
);

export default AssetRow;
